<template>
  <div class="home">
    <h1 class="mt-16 text-h4 font-weight-bold text-center">
      {{ $city.name }}政府健檢預約平台
    </h1>
    <h2 class="my-4 text-h5 font-weight-bold text-center">
      恭喜您，您已經完成25％的篩檢評估
    </h2>
    <v-form ref="form" v-model="valid" lazy-validation>
      <QuestionContent
        :person.sync="person"
        :valid.sync="valid"
        :問卷.sync="問卷"
      ></QuestionContent>
    </v-form>
    <v-row justify="center">
      <v-col class="col-auto">
        <v-btn
          @click="$router.go(-1)"
          class="mt-12 px-12 mx-2"
          x-large
          color="primary"
        >
          上一頁
        </v-btn>
        <v-btn @click="save" class="mt-12 px-12 mx-2" x-large color="primary">
          下一頁
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import QuestionContent from "@/components/QuestionContent/Q2";
export default {
  name: "Q2",
  components: { QuestionContent },
  async created() {
    this.person = { ...this.$store.state.person };
    this.問卷 = this.person.問卷 || {};
  },
  data: () => ({
    valid: false,
    person: null,
    問卷: null,
  }),
  methods: {
    save() {
      // this.valid = this.$refs.form.validate();
      // if (this.valid) {
      let person = { ...this.person };
      person.問卷 = this.問卷;
      this.$store.commit("setState", { person });
      this.$router.push("/questionnaire/3");
      // }
    },
  },
};
</script>
